import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import GameTile from '../../gameTile/containers/GameTile';
import placeListsLayout from '../constants/placeListsLayout';
import { getGameSortId } from '../../../../ts/react/common/utils/parsingUtils';
import { PageContext } from '../../../../ts/react/common/constants/eventStreamConstants';
import useGameImpressionCarouselTracker from '../../../../ts/react/common/hooks/useGameImpressionCarouselTracker';

const { pageTypes } = placeListsLayout;
function ListOfGamesComponent({
  gamesData,
  name,
  sort,
  pageContext,
  pageType,
  sortPosition,
  isInitializedLoading,
  friendsData,
  gameDetailPlaceId,
  ...props
}) {
  const gameCarouselRef = useRef();
  const gameTileRef = useRef();

  const [listOfGames, setListOfGames] = useState(gamesData);

  useGameImpressionCarouselTracker(gameCarouselRef, gameTileRef, listOfGames, {
    sortPos: sortPosition,
    gameSetTargetId: sort.gameSetTargetId,
    gameSetTypeId: getGameSortId(sort.name),
    pg: pageType === pageTypes.home ? PageContext.HomePage : PageContext.GameDetailPage
  });

  useEffect(() => {
    if (gamesData?.length) {
      setListOfGames(gamesData);
    }
    return () => {};
  }, [gamesData]);

  return (
    <ul ref={gameCarouselRef} className='hlist game-cards'>
      {listOfGames.length > 0 &&
        listOfGames.map((game, index) => {
          const keyValue = `${game.universeId}${index}`;
          return (
            <li
              className='list-item game-card game-tile'
              id={game.universeId}
              key={keyValue}
              title={game?.name}>
              {game?.universeId && (
                <GameTile
                  game={game}
                  pageType={pageType}
                  ref={gameTileRef}
                  index={index}
                  sortName={name}
                  pageContext={pageContext}
                  sortPosition={sortPosition}
                  friendsData={friendsData}
                  gameDetailPlaceId={gameDetailPlaceId}
                  {...props}
                />
              )}
            </li>
          );
        })}
    </ul>
  );
}

ListOfGamesComponent.defaultProps = {
  sort: {},
  friendsData: [],
  pageType: '',
  gameDetailPlaceId: null,
  name: ''
};

ListOfGamesComponent.propTypes = {
  sort: PropTypes.shape({
    token: PropTypes.string,
    displayName: PropTypes.string,
    name: PropTypes.string,
    numberOfRows: PropTypes.number,
    gameSetTargetId: PropTypes.number,
    contextCountryRegionId: PropTypes.number,
    timeOptionsAvailable: PropTypes.bool,
    numberOfGames: PropTypes.number
  }),
  gamesData: PropTypes.arrayOf(PropTypes.shape({ universeId: PropTypes.number })).isRequired,
  name: PropTypes.string,
  pageContext: PropTypes.shape({ pageId: PropTypes.string }).isRequired,
  sortPosition: PropTypes.number.isRequired,
  isInitializedLoading: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
  friendsData: PropTypes.arrayOf(
    PropTypes.shape({
      presense: PropTypes.shape({ userPresenceType: PropTypes.number }),
      id: PropTypes.number,
      nameForDisplay: PropTypes.string
    })
  ),
  pageType: PropTypes.string,
  gameDetailPlaceId: PropTypes.number
};

export default ListOfGamesComponent;
